module.exports = {
    viasName: () => {
        return[
            ["Doble Calzada Villavicencio - Yopal", "Vía Wyndham Garden Hotel","Vía Entrada Restrepo", "Vía Balcones","Calle Real", "Vía La Valvanera","Vía Transversal", "Vía Comercial"]
        ]
    }
}